export const enum Theme {
  DARK = 'dark',
  LIGHT = 'light'
}
